import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { email, srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';
import { Icon } from '@components/icons';
import { AiOutlineCopy } from 'react-icons/ai';

const StyledContactSection = styled.section`
  max-width: 900px;
  margin: 0 auto 100px;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--primary);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-right: 10px;
  }

  .email-me {
    margin-top: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .email-copy {
    width: 30px;

    :hover {
      color: var(--primary);
      transform: translateY(-7px);
      transition: var(--transition);
    }
  }
`;

const Contact = function () {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const _onCopyEmailId = (e) => {
    const el = document.createElement('textarea');
    el.value = email;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  return (
    <StyledContactSection id = "contact" ref = {revealContainer}>
      <h2 className = "numbered-heading">Contact Me</h2>
      <p>
        I’m always open for exiting new opportunities and working with motivated people.
      </p>
      <div className = "email-me">
        <a className = "email-link" href = {`mailto:${email}`}>
          Email Me
        </a>
        <div className = "email-copy"><AiOutlineCopy onClick = {_onCopyEmailId} /></div>
      </div>
    </StyledContactSection>
  );
};

export default Contact;
